import { useMemo } from 'react';

import { NekuodahProps } from '../../types/NekuodahProps';
import { getLevels } from './logic/getLevels';

export const useNekuodah = (
  components: NekuodahProps['components'],
  children: NekuodahProps['children'],
) => {
  const levels = useMemo(
    () => getLevels(components, children),
    [components, children],
  );

  return levels;
};
